import { render, staticRenderFns } from "./schedules-component.vue?vue&type=template&id=bab6f01c&"
import script from "./schedules-component.vue?vue&type=script&lang=js&"
export * from "./schedules-component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports